import { createPersistentComponentLayer } from "@imminently/decisively-ui/PersistentComponents";

export const WORKSPACE_LAYER = createPersistentComponentLayer("workspace");
export const RELEASE_LAYER = createPersistentComponentLayer("release");
